import { render, staticRenderFns } from "./MenuWebsite.vue?vue&type=template&id=600b2ae7&scoped=true&"
import script from "./MenuWebsite.vue?vue&type=script&lang=js&"
export * from "./MenuWebsite.vue?vue&type=script&lang=js&"
import style0 from "./MenuWebsite.vue?vue&type=style&index=0&id=600b2ae7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b2ae7",
  null
  
)

export default component.exports